import type { OverlayProps } from './Overlay'
import { Overlay } from './Overlay'

export type SheetProps = OverlayProps

/**
 * Bottom sheet. The default modal on a phone: it opens under the thumb, not under the
 * status bar. Use it for search, quick-add, and anything picked one-handed.
 */
export function Sheet(props: SheetProps) {
  return <Overlay kind="sheet" {...props} />
}
